module.exports = __webpack_public_path__ + "static/media/lide.db03be71.png";